import type { FC } from 'react';

import { useSideBarEffects } from './SideBar.effects.js';
import { Drawer } from './SideBar.styles.js';
import type { SideBarProps } from './SideBar.types.js';

export const SideBar: FC<SideBarProps> = ({ isNavOpen, children }) => {
  const { drawerOpen, drawerVariant } = useSideBarEffects({ isNavOpen });

  return (
    <Drawer open={drawerOpen} anchor="left" variant={drawerVariant} role="navigation" aria-label="Main navigation">
      {children}
    </Drawer>
  );
};
